import { AppModule } from "@/shared/types";
import DashboardIwk from "./index.vue";

const DashboardIwkModules: AppModule = {
  rootLink: "/",
  rootIcon: "mdi-view-dashboard",
  rootName: "Dashboard",
  layout: "Sidebar",
  authRequired: true,
  children: [
    {
      path: "/",
      name: "Dashboard",
      component: DashboardIwk,
    },
  ],
};

export default DashboardIwkModules;
